import React from 'react';
import { Bell, Clock, AlertCircle, Trash2 } from 'lucide-react';

const Alerts = ({ alertManager }) => {
  const handleClearAlerts = () => {
    if (alertManager.clearAlerts && typeof alertManager.clearAlerts === 'function') {
      alertManager.clearAlerts();
    }
  };

  return (
    <div className="page-section">
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '8px' }}>
          Alert Management Center
        </h2>
        <p style={{ fontSize: '16px', color: 'var(--text-secondary)' }}>
          Monitor and manage all your trading alerts in one place
        </p>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
        marginBottom: '24px'
      }}>
        <div className="dashboard-card">
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{
              width: '48px', height: '48px', borderRadius: '50%',
              background: 'rgba(252, 213, 53, 0.2)', color: 'var(--accent-gold)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '20px', flexShrink: 0
            }}>
              <Bell size={20} />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '24px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '4px' }}>
                {alertManager.getTotalAlertsCount?.() || 0}
              </div>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                Total Alerts
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-card">
        <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Recent Alerts</h3>
          {alertManager.alerts?.length > 0 && (
            <button
              onClick={handleClearAlerts}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                color: '#ef4444',
                border: '1px solid rgba(239, 68, 68, 0.2)',
                borderRadius: '6px',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(239, 68, 68, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'rgba(239, 68, 68, 0.1)';
              }}
            >
              <Trash2 size={14} />
              Clear All
            </button>
          )}
        </div>
        <div className="card-content">
          {alertManager.alerts?.length === 0 ? (
            <div className="empty-state">
              <Bell size={48} style={{ opacity: 0.5, marginBottom: '16px' }} />
              <h3>No alerts yet</h3>
              <p>Start monitoring to receive real-time notifications</p>
            </div>
          ) : (
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {alertManager.alerts?.slice(0, 10).map((alert, index) => (
                <div key={index} className="activity-item">
                  <div className={`activity-icon ${alert.type}`}>
                    <Bell size={14} />
                  </div>
                  <div className="activity-content">
                    <div className="activity-title">{alert.source}: {alert.symbol}</div>
                    <div className="activity-time">{new Date(alert.timestamp).toLocaleString()}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Alerts;